<script setup>
import axios from "axios";
import {reactive, ref, watch} from "vue";
import {ElTabs,ElTabPane,ElButton,ElSelect,ElOption,ElInputNumber,ElLoading,ElDrawer,ElRow,ElCol,ElFormItem,ElForm,ElDatePicker} from "element-plus";
import { moneyTotal, roundMoney } from '../../../utils/money';

const emit = defineEmits(['canceli','added','addflight']);

const props = defineProps({
    form:Object
});

const form=props.form;


const flightmodel=ref(true);

const ruleFormRef = ref();



const editform = reactive({
    data:null,
    pricing:{
        total:0,
        adult:0 ,
        child:0 ,
        infant:0 ,
    },
    refundable:null

});

const rules = reactive({
    data: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ]

});


let result=ref(null);

const submitForm = async (formEl) => {

    if (!formEl) return
    await formEl.validate((valid, fields) => {
        if (valid) {

            emit('addflight', {
                ...editform,
                pricing: {
                    total: roundMoney(editform.pricing.total),
                    adult: roundMoney(editform.pricing.adult),
                    child: roundMoney(editform.pricing.child),
                    infant: roundMoney(editform.pricing.infant),
                }
            })

        }
    })
}







// Handle the paste event
const handlePaste = async (event) => {
    const items = event.clipboardData.items;

    // Loop through the clipboard items
    for (let i = 0; i < items.length; i++) {
        const item = items[i];

        // Check if the item is an image
        if (item.type.startsWith('image/')) {
            // Get the image file
            const file = item.getAsFile();

            // Create an object URL for the image
            if (file) {

                var reader = new FileReader();
                reader.onloadend = function() {
                    editform.data = reader.result;
                }
                reader.readAsDataURL(file);
            }
        }
    }
};


const updateupricecount = () => {
    editform.pricing.total = moneyTotal(form.adults, editform.pricing.adult, form.childs, editform.pricing.child, form.infants, editform.pricing.infant);
};


watch(
    () => editform.pricing.adult,
    () => {
        updateupricecount();
    }
)

watch(
    () => editform.pricing.child,
    () => {
        updateupricecount();
    }
)

watch(
    () => editform.pricing.infant,
    () => {
        updateupricecount();
    }
)

</script>

<template>
    <el-drawer
        v-model="flightmodel"
        title="Add Flight"
        @closed="emit('canceli')"
        size="90%"
    >
        <el-form
            label-position="top"
            ref="ruleFormRef"
            :model="editform"
            status-icon
            :rules="rules"
            v-if="result==null"
        >
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item label="Image" prop="data">
                        <input type="text" @paste="handlePaste" placeholder="Paste an image here" />
                    </el-form-item>

                </el-col>
                <el-col :span="24">
                    <div v-if="editform.data">
                        <img :src="editform.data" alt="Pasted Image" />
                    </div>
                </el-col>

            </el-row>
            <el-row :gutter="20">
                <el-col :span="4" >
                    <el-form-item label="Adults" >
                        <el-input v-model="form.adults"  placeholder="Adults" readonly/>
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Adult Pricing" prop="pricing.adult"  :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.adult"  placeholder="Adult Pricing" type="number" />
                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20" v-if="form.childs>0">
                <el-col :span="4" >
                    <el-form-item label="Child" >
                        <el-input v-model="form.childs"  placeholder="Child" readonly/>
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Child Pricing" prop="pricing.child"  :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.child"  placeholder="Child Pricing"  type="number"  />
                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20" v-if="form.infants>0">
                <el-col :span="4" >
                    <el-form-item label="Infants" >
                        <el-input v-model="form.infants"  placeholder="Infants" readonly/>
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Infants Pricing" prop="pricing.infant"  :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.infant"  placeholder="Infants Pricing"  type="number"/>
                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20" >
                <el-col :span="4" >


                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Total Pricing" prop="pricing.total"  :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.total"  placeholder="Total Pricing"  type="number" readonly/>
                    </el-form-item>

                </el-col>


            </el-row>

            <el-row :gutter="20" >

                <el-col :span="4" >
                    <el-form-item label="Refundable" prop="refundable">
                        <el-switch v-model="editform.refundable">

                        </el-switch>
                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20" >

                <el-col :span="4" >
                    <el-button type="primary" @click="submitForm(ruleFormRef)">Add Flight</el-button>

                </el-col>


            </el-row>
        </el-form>

    </el-drawer>
</template>

<style scoped>

</style>
